import { type NavigationItem } from '../../../../utils/types/navigation-items';

export const getCurrentPageSubItemIds = (navigationItems: NavigationItem[], pathname: string) => {
  const currentPageSubItems =
    navigationItems.find((navItem) => navItem.route === pathname)?.subMenu || [];
  return currentPageSubItems.map((navItem) => navItem.route.replace('#', ''));
};
